import {h, Fragment} from "preact"
import { useActions, useAppState, useProductFilters } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks";
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import { sortWashes } from '../helpers'

export default function({ sidebarOpen, toggleSidebar }) {
    const { loading, response: { products: { facets } } = {} } = useAppState();
    const { updateSearch } = useActions();
    const { filters, removeAll } = useProductFilters();
    const [ checkedFilters, setCheckedFilters ] = useState([]);

    useEffect(() => {
        setCheckedFilters(filters.map((f) => {
            return {
                facet: f.field,
                value: f.value,
                selected: true,
            }
        }));
    }, [filters.length]);
    
    const handleApplyAllFilters = () => {
        const uniqueValues = {};
        
        checkedFilters.forEach(item => {
            const { facet, value, selected } = item;
            if (!selected || facet === "price") return;
            if (!uniqueValues[facet]) {
                uniqueValues[facet] = {
                    field: facet,
                    value: [value],
                };
            } else {
                if (!uniqueValues[facet].value.includes(value)) {
                    uniqueValues[facet].value.push(value);
                }
            }
        });
    
        const formattedFilters = Object.values(uniqueValues);
        const priceFilter = filters?.find(f => f.field === 'price');
        if(priceFilter) {
            formattedFilters.push(priceFilter.filter);
        }
        updateSearch({
            products: {
                filter: formattedFilters
            },
        })
        toggleSidebar();
    };

    const handleClearAll = () => {
        setCheckedFilters([]);
        removeAll();
        toggleSidebar();
    }

    return facets?.length > 0 ? (
        <>
            <div
                class={`ns-sidebar-backdrop h-full fixed overflow-hidden ${sidebarOpen ? "active w-full" : "w-0"}`}
                role="button"
                tabindex="0"
                aria-label="Background Filters Overlay"
                onClick={toggleSidebar}
            ></div>
            <div
                class={`ns-sidebar-wrapper fixed lg:absolute ${sidebarOpen ? "open" : "hidden"}`}
            >
                <div class="ns-sidebar-content relative w-full max-w-[1112px] h-full flex flex-col lg:flex-row mx-auto">
                    {/* Header */}
                    <div class="ns-sidebar-header flex items-center p-4 m-0 capitalize lg:hidden">
                        <div class="flex flex-nowrap items-center">
                            Filter
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" fill="none" class="ml-2">
                                <path stroke="#000" stroke-linecap="round" stroke-width="1.5" d="M1 8.75h12"></path><circle cx="9.25" cy="8.75" r="1.75" fill="#000" stroke="#000"></circle><path stroke="#000" stroke-linecap="round" stroke-width="1.5" d="M1 2.375h12"></path><circle cx="5.25" cy="2.25" r="1.75" fill="#000" stroke="#000"></circle>
                            </svg>
                        </div>
                    </div>

                    {/* Dropdowns */}
                    <div class="ns-sidebar-menu lg:flex lg:flex-nowrap lg:justify-between">
                        {facets?.map(facet => {
                            switch (facet.type) {
                                case "terms":
                                    if(facet.name === 'Washes') {
                                        sortWashes(facet.data);
                                    }
                                    return <Facet 
                                        facet={facet} 
                                        checkedFilters={checkedFilters}
                                        setCheckedFilters={setCheckedFilters}
                                    />
                                case "stats":
                                    return <RangeFacet facet={facet} />
                                default:
                                    return null
                            }
                        })}
                    </div>

                    {/* Desktop Options */}
                    <div class="desktop-toggles hidden lg:flex flex-col">
                        <button type="button" class="ns-apply-all-btn" onClick={handleApplyAllFilters}>Apply Filters</button>
                        {(checkedFilters.length > 0) && 
                            <button type="button" class="ns-clear-all-btn underline" onClick={handleClearAll}>Clear All</button>
                        }
                        <button type="button" class="ns-close-sidebar-btn underline" onClick={toggleSidebar}>Close</button>
                    </div>
                </div>
            </div>
        </>
    ) : ( null )
}
